import { Component } from '@angular/core';

@Component({
  selector: 'user-section-wrapper',
  standalone: true,
  imports: [],
  template: `
    <ng-content/>
    
  `,
  styleUrl: './user-section-wrapper.component.scss'
})
export class UserSectionWrapperComponent {

}
